import type { ErrorComponentProps } from "@tanstack/react-router";
import { Link, useRouter } from "@tanstack/react-router";
import { btn } from "@/components/ds/styles";

const primary = btn.primary;
const secondary = btn.secondary;
const ghost = `${btn.link} px-3`;

/** v3 status block shared by 404 and error screens (no shell; the caller decides). */
export function StatusBlock({ kind, onRetry }: { kind: "404" | "error"; onRetry?: () => void }) {
  const nf = kind === "404";
  return (
    <div dir="rtl" className="mx-auto max-w-[44rem] px-5 py-16 lg:py-24">
      <p className="font-display text-[14px] font-bold text-amber-800">{nf ? "404" : "خطأ"}</p>
      <h1 className="mt-2 font-display text-[34px] font-extrabold leading-tight text-maroon-500">
        {nf ? "هالصفحة مش موجودة." : "صار شي غلط."}
      </h1>
      <p className="mt-3 text-[17px] leading-[1.85] text-brown-500">
        {nf ? "ممكن الرابط تغيّر أو انحذف. الرئيسية فيها كل شي." : "ما قدرنا نعرض الصفحة هلّق. منجرّب كمان مرة؟"}
      </p>
      <div className="mt-8 flex flex-wrap items-center gap-3">
        <Link to="/" className={primary}>الرئيسية ←</Link>
        <Link to="/contact" className={secondary}>التواصل</Link>
        {onRetry && <button type="button" onClick={onRetry} className={ghost}>إعادة المحاولة</button>}
      </div>
    </div>
  );
}

/** Route-level error boundary (renders inside the route's own layout). */
export function RouteError({ reset }: ErrorComponentProps) {
  const router = useRouter();
  return <StatusBlock kind="error" onRetry={() => { router.invalidate(); reset(); }} />;
}

export function RouteNotFound() {
  return <StatusBlock kind="404" />;
}
